<template>
  <div class="button" :class="{ 'button--disabled': disabled }" @click="handleClick">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      console.log("handleClick");
      if (this.disabled) return;
      this.$emit("onClick");
    },
  },
};
</script>

<style lang="sass" scoped>
$primary: $blue-6
$gray: $gray-6

.button
  color: $primary
  width: 100%
  padding: 8px
  text-align: center
  border: 1px dashed $primary
  border-radius: 8px
  cursor: pointer

  &--disabled
    color: $gray
    border: 1px dashed $gray
    cursor: not-allowed
</style>
